import { filterOptions } from '@/utils/query-base'

const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export const pageSearch = {
  'type': {
    title: '生产计划类型',
    type: 'select',
    equation: city,
    dictionary: 'A0006'
  },
  'prod_id': {
    title: '计划编号',
    type: 'input',
    equation: all
  },
  'datum': {
    title: '订单日期',
    type: 'date',
    equation: all
  },
  'partner': {
    title: '订单客户',
    type: 'dialog',
    equation: cusname,
    dialog: {
      component: 'ClientSelect',
      title: '订单客户'
    }
  },
  'name': {
    title: '客户名称',
    type: 'input',
    equation: all
  },
  'salescenter': {
    title: '营销单元',
    type: 'select',
    equation: all,
    dictionary: 'sale'
  }
}

export const config1 = {
  'prodpl_id': {
    title: '生产计划单'
  },
  'prodpl_item': {
    title: '项目',
    width: 70
  },
  'product_id': {
    title: '产品编号',
    width: 180
  },
  'description': {
    title: '描述',
    width: 400
  },
  'wlybrand': {
    title: '品牌'
  },
  'name1': {
    title: '客户名称',
    width: 250
  },
  'version': {
    title: '版本号'
  },
  'planqty_box': {
    title: '计划数量(件)',
    xlsxFmt: {
      t: 'n',
      z: '0.000'
    }
  },
  'planqty_bottle': {
    title: '计划数量(瓶)',
    xlsxFmt: {
      t: 'n',
      z: '0.000'
    }
  },
  'planqty_ton': {
    title: '计划数量(吨)',
    xlsxFmt: {
      t: 'n',
      z: '0.000'
    }
  },
  'area': {
    title: '区域'
  },
  'abclv': {
    title: '优先级'
  },
  'status': {
    title: '状态'
  },
  'packsum_id': {
    title: '汇总单'
  },
  'uname': {
    title: '制单人'
  },
  'mdate': {
    title: '提交日期'
  }
}
export const config2 = {
  'prodsum_id': {
    title: '汇总单号'
  },
  'prodpl_item': {
    title: '项目',
    width: 60
  },
  'product_id': {
    title: '产品编号',
    width: 180
  },
  'wlybrand': {
    title: '品牌'
  },
  'description': {
    title: '描述',
    width: 400
  },
  'version': {
    title: '版本号'
  },
  'planqty_box': {
    title: '计划数量(件)',
    xlsxFmt: {
      t: 'n',
      z: '0.000'
    }
  },
  'planqty_bottle': {
    title: '计划数量(瓶)',
    xlsxFmt: {
      t: 'n',
      z: '0.000'
    }
  },
  'planqty_ton': {
    title: '计划数量(吨)',
    xlsxFmt: {
      t: 'n',
      z: '0.000'
    }
  },
  'area': {
    title: '区域'
  },
  'abclv': {
    title: '优先级'
  },
  'status': {
    title: '状态'
  },
  'remark': {
    title: '备注',
    slot: true,
    width: 200
  }
}




// WEBPACK FOOTER //
// ./src/views/make-plan-manage/config/makeSumOrder.js